/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 충전 콘텐츠 조회 응답
 */
export type GetEvBatteryManagementChargeResponse = {
  /**
   * 업데이트 날짜 (형식: yyyyMMdd)
   */
  lastUpdatedDate: string;
  /**
   * 충전 횟수
   */
  chargeCount: number;
  /**
   * 완속충전 횟수
   */
  normalChargingCount: number;
  /**
   * 급속충전 횟수
   */
  fastChargingCount: number;
  /**
   * 고객 평균 완속충전 횟수
   */
  avgNormalChargingCount: number;
  /**
   * 고객 평균 급속충전 횟수
   */
  avgFastChargingCount: number;
  /**
   * 충전 시작 SoC (0 이상 100 이하 실수, 0.5 단위)
   */
  chargeStartSoC: number;
  /**
   * 충전 종료 SoC (0 이상 100 이하 실수, 0.5 단위)
   */
  chargeEndSoC: number;
  /**
   * 고객 평균 충전 시작 SoC (0 이상 100 이하 실수, 0.5 단위)
   */
  avgChargeStartSoC: number;
  /**
   * 고객 평균 충전 종료 SoC (0 이상 100 이하 실수, 0.5 단위)
   */
  avgChargeEndSoC: number;
  /**
   * 충전 정보 타이틀 상태
   */
  chargingStatus: GetEvBatteryManagementChargeResponse.chargingStatus;
  /**
   * 급속충전 상태
   */
  fastChargingStatus: GetEvBatteryManagementChargeResponse.fastChargingStatus;
  /**
   * 배터리 잔량 상태
   */
  batteryLevelStatus: GetEvBatteryManagementChargeResponse.batteryLevelStatus;
};
export namespace GetEvBatteryManagementChargeResponse {
  /**
   * 충전 정보 타이틀 상태
   */
  export enum chargingStatus {
    NONE = 'NONE',
    ACTIVE = 'ACTIVE',
  }
  /**
   * 급속충전 상태
   */
  export enum fastChargingStatus {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
  }
  /**
   * 배터리 잔량 상태
   */
  export enum batteryLevelStatus {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
    DEFAULT = 'DEFAULT',
  }
}

